import React from 'react';
import {Form} from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import {DateTime} from 'luxon';

interface DatePickerFieldProps {
  name: string;
  value: string | null;
  onChange: (value: string | null) => void;
  placeholder?: string;
  isRequired?: boolean;
  error?: string;
  touched?: boolean;
  dateFormat?: string;
  isClearable?: boolean;
  disabled?: boolean;
}

const DatePickerField: React.FC<DatePickerFieldProps> = ({
    name,
    value,
    onChange,
    placeholder,
    isRequired,
    error,
    touched,
    dateFormat = 'dd/MM/yyyy',
    isClearable = true,
    disabled = false,
}) => {
    const hasError = touched && !!error;

    return (
        <div>
            <DatePicker
                wrapperClassName="w-100"
                autoComplete="off"
                disabled={disabled}
                selected={
                    value
                        ? DateTime.fromFormat(value, 'yyyy-MM-dd').toJSDate()
                        : null
                }
                onChange={(date: Date | null) => {
                    const formattedValue = date ? DateTime.fromJSDate(date).toFormat('yyyy-MM-dd') : null;
                    onChange(formattedValue);
                }}
                isClearable={isClearable}
                dateFormat={dateFormat}
                customInput={(
                    <Form.Control
                        type="text"
                        name={name}
                        placeholder={placeholder}
                        isInvalid={hasError}
                    />
                )}
            />
            {hasError && (
                <Form.Control.Feedback
                    type="invalid"
                    style={{
                        display: 'block',
                    }}
                >
                    {error}
                </Form.Control.Feedback>
            )}
        </div>
    );
};

export default DatePickerField;
